module.exports = __webpack_public_path__ + "static/media/transf1.6520f699.jpg";